<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style>
  body{
    margin: 0px;
    padding: 0px;
  }
  #app {
    font-family: "PingFang SC","Microsoft YaHei","微软雅黑",Arial,"Helvetica Neue",Helvetica,"Hiragino Sans GB",sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .g-text-overflow-ellipsis{
    text-overflow:ellipsis; white-space:nowrap; overflow:hidden;
  }
  span.g-text-overflow-ellipsis{
    display: inline-block;
  }


  @font-face {
    font-style: normal;
    font-family: 'HarmonyOS_SansSC';
    /*引入HarmonyOS_Sans_SC，目录别搞错*/
    src: url('../static/fonts/HarmonyOS_SansSC/HarmonyOS_SansSC_Bold.ttf') format('truetype');
  }
</style>
